import React, { useCallback } from 'react';
import Slider from 'react-slick';
import { Image } from '@src/interfaces';
import ImageComponent from '@src/components/Image/ImageComponent';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import { trackEvent } from '@src/utils/et';
import { Models } from '@data/et-web-api';
import { CustomSliderRef } from '../TeaserSlider/TeaserSlider';

const SLIDER_SETTINGS = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 125,
  arrows: false,
  adaptiveHeight: true,
};

const GalleryParagraph = (props: ParagraphProps) => {
  const images = props.paragraph.data.images as Image[];
  let sliderRef: CustomSliderRef | null;

  const trackGalleryClick = useCallback((index: number) => {
    const eventName: Models.GalleryClick['eventName'] = 'Gallery Click';
    const total = props.paragraph.data.images.length;
    const eventPayload = {
      galleryName: props.paragraph.data.title,
      picturePosition: `${index+1}`,
      numberOfPictures: total,
    };
    trackEvent(eventName, eventPayload)
  }, [props.paragraph.data])

  const imageCollection = images.map((image: Image, index: number) => (
    <figure key={index} className="gallery-image">
      <ImageComponent image={image} showDescription size="large_uncropped" />
    </figure>
  ));

  const onClickPrev = () => {
    if (sliderRef) sliderRef.slickPrev();
  };

  const onClickNext = () => {
    if (sliderRef) sliderRef.slickNext();
  };

  return (
    <section className="paragraph gallery-paragraph">
      <button
        aria-label="Vorheriges Bild"
        className="btn btn-icon button-left"
        onClick={onClickPrev}
        type="button"
      >
        <i className="icon icon-arrow-left" />
      </button>

      <button
        aria-label="Nächstes Bild"
        className="btn btn-icon button-right"
        onClick={onClickNext}
        type="button"
      >
        <i className="icon icon-arrow-right" />
      </button>

      <Slider
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref={(c: any) => {
          sliderRef = c;
        }}
        {...SLIDER_SETTINGS}
        beforeChange={(_currentSlide: number, nextSlide: number) => trackGalleryClick(nextSlide)}
      >
        {imageCollection}
      </Slider>
    </section>
  );
};

export default GalleryParagraph;
